import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=17c98d5e&scoped=true&"
import script from "./OrderHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c98d5e",
  null
  
)

export default component.exports